import {
  AfterViewInit,
  Component,
  Input,
  OnChanges,
  OnInit,
  OnDestroy,
  ElementRef,
  SimpleChanges,
  ViewChild,
  Renderer2,
} from "@angular/core";

import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  ValidatorFn,
  Validators,
} from "@angular/forms";

import { BehaviorSubject, Subject, Subscription } from "rxjs";
import { auditTime, debounceTime, takeUntil } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";
import Swal from "sweetalert2";

// Ck Editer
import * as ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import { EventService } from "src/app/core/services/event.service";
import { PropertiesService } from "../../services/properties.services";
import { PermissionsService } from "src/app/core/services/permissions.service";
import { PropertyValidationRulesService } from "src/app/core/services/propertyValidationRules.service";
import { AiCreditRequestContext, AiIntegrationsService } from "src/app/core/services/ai-integrations.service";
import { AiWalletStateService } from "src/app/core/services/ai-wallet-state.service";
import { AiUsageLinkStateService } from "src/app/core/services/ai-usage-link-state.service";
import { PropertyDataService, PropertyFormData } from "src/app/core/services/property-data.service";
type ErrorItem = { key: string; type: { warning?: true; required?: true } };

@Component({
  selector: "app-advertisement1",
  templateUrl: "./advertisement.component.html",
  styleUrls: ["./advertisement.component.scss"],
})
export class AdvertisementComponent
  implements OnInit, OnChanges, AfterViewInit, OnDestroy
{
  readonly titleSoftLimit = 120;
  readonly descriptionGoodMin = 800;
  readonly descriptionExcellentMin = 2500;
  readonly descriptionGoodMax = 4000;

  @Input() dataToFormInitAdvertisement: any;
  @Input() dataToFormInitAreasNearby: any;
  @Input() dataToFormInitChar: any;
  @Input() submitted = false;
  @Input() property: any;
  @Input() propertyAreasNearbyData: any;
  @Input() propertyCharateristicsData: any;
  @Input() propertyAdvertisementData: any;
  @Input() isActive!: BehaviorSubject<number>;

  propertyAdvertisementForm!: FormGroup;

  public editorPT = ClassicEditor;
  public editorEN = ClassicEditor;

  subscriptionSubmitted!: Subscription;
  subscriptions!: Subscription;
  isView = false;
  activeTabSubject$: BehaviorSubject<number>;

  @ViewChild("formElementRef") formElementRef!: ElementRef;
  @ViewChild("titleDescRef") titleDescRef!: ElementRef;
  @ViewChild("statusRef") statusRef!: ElementRef;

  nabTabActive = 0;
  activeId: any;
  securityActive: any;
  loginUser!: {
    id?: string;
    role?: { id?: string; name?: string };
    stores?: any[];
  };

  private destroy$ = new Subject<void>();

  // AI Integration
  aiLoading: Record<string, boolean> = {};
  aiCreditPops: Record<string, { text: string; id: number }> = {};
  private _popCounter = 0;
  aiFillingFields: Record<string, boolean> = {};
  aiFieldResults: Record<string, string> = {};
  private activeTypewriterTimers: Record<string, any> = {};
  private pendingTypewriterFinalValues: Record<string, { controlName: string; text: string }> = {};
  aiTranslationPulse = false;
  aiServiceAvailabilityLoaded = false;
  canRequestCreditTopUps = true;
  activatedAiServices = new Set<string>();
  /** Custo do próximo uso (0 quando o primeiro título do imóvel é grátis). */
  aiServiceCosts: Record<string, number> = {};
  /** Custo configurado, para repor depois do uso grátis. */
  aiServiceBaseCosts: Record<string, number> = {};
  aiFreeFirstUse = new Set<string>();
  creditRequestContext: AiCreditRequestContext | null = null;
  propertyFormDataSnapshot: PropertyFormData = {};
  aiLatestResult: {
    kind: "TITLE" | "DESCRIPTION" | "TRANSLATION";
    headline: string;
    detail?: string;
    preview?: string;
    at: number;
  } | null = null;

  constructor(
    private eventService: EventService,
    private formBuilder: FormBuilder,
    private propertiesService: PropertiesService,
    private renderer: Renderer2,
    public permissionsService: PermissionsService,
    private propertyValidationService: PropertyValidationRulesService,
    private aiService: AiIntegrationsService,
    private aiWalletState: AiWalletStateService,
    private aiUsageLink: AiUsageLinkStateService,
    private translateService: TranslateService,
    private propertyDataService: PropertyDataService,
  ) {
    this.subscriptions = new Subscription();
    this.activeTabSubject$ = new BehaviorSubject<number>(1);
  }

  ngOnInit(): void {
    const { id, role, stores } = this.propertiesService.getUserAuth();
    this.loginUser = { id, role, stores };
    this.activeId = this.dataToFormInitAdvertisement?.activeId;
    this.initFormValidation();

    this.propertyDataService.propertyFormData$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.propertyFormDataSnapshot = data ?? {};
      });

    if (this.canShowAiOptions) {
      this.loadActivatedAiServices();
      this.loadCreditRequestContext();
    } else {
      this.aiServiceAvailabilityLoaded = true;
      this.activatedAiServices = new Set<string>();
    }

    this.propertyValidationService
      .rules$()
      .pipe(takeUntil(this.destroy$))
      .subscribe((map) => {
        if (!map?.size || !this.propertyAdvertisementForm) return;

        const revalidateTree = (ctrl: AbstractControl) => {
          if (ctrl instanceof FormGroup) {
            Object.values(ctrl.controls).forEach(revalidateTree);
          }

          ctrl.updateValueAndValidity({ emitEvent: false });
        };

        revalidateTree(this.propertyAdvertisementForm);
      });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      let act = 0;

      for (let lang of this.dataToFormInitAdvertisement?.langs) {
        act++;

        if (this.hasLangTitleWarning(lang)) {
          const data: any = {};

          data[`lang${lang.id}_main`] = false;

          this.propertyAdvertisementForm.patchValue(data, { emitEvent: false });
        } else if (
          this.propertyAdvertisementForm.get(`lang${lang.id}_main`)?.value ===
          true
        ) {
          this.activeTabSubject$.next(act);
        }
      }

      this.isActive.asObservable().subscribe((val) => {
        if (val > 0) {
          for (let option of this.dataToFormInitAdvertisement?.options) {
            const data: any = {};

            data[`option${option.id}`] = false;

            this.propertyAdvertisementForm.patchValue(data, {
              emitEvent: false,
            });
          }
        }
      });

      this.subscriptionSubmitted = this.eventService.subscribe(
        "get-data-tab-advertisement",
        (data) => {
          if (data?.submitted)
            for (let lang of this.dataToFormInitAdvertisement?.langs) {
              if (
                !this.propertyAdvertisementForm.get(`lang${lang.id}_title`)
                  ?.value ||
                this.propertyAdvertisementForm
                  .get(`lang${lang.id}_title`)
                  ?.value?.trim()?.length === 0
              ) {
                const title: any = [];

                title[`lang${lang.id}_title`] = "N/A";

                this.propertyAdvertisementForm.patchValue(title, {
                  emitEvent: false,
                });

                const data: any = {};

                data[`lang${lang.id}_main`] = false;

                this.propertyAdvertisementForm.patchValue(data, {
                  emitEvent: false,
                });
              }
            }

          if (this.dataToFormInitAdvertisement?.langs.length > 0) {
            const l1 = this.dataToFormInitAdvertisement?.langs.filter(
              (lang: any) => {
                return (
                  this.propertyAdvertisementForm.get(`lang${lang.id}_main`)
                    ?.value === true && !this.hasLangTitleWarning(lang)
                );
              },
            );

            if (l1?.length === 0) {
              const l2 = this.dataToFormInitAdvertisement?.langs.filter(
                (lang: any) => {
                  return !this.hasLangTitleWarning(lang);
                },
              );

              if (l2?.length > 0) {
                const lang = l2[0];

                const data: any = {};

                data[`lang${lang.id}_main`] = true;

                this.propertyAdvertisementForm.patchValue(data, {
                  emitEvent: false,
                });
              } else {
                const lang = this.dataToFormInitAdvertisement?.langs[0];
                const data: any = {};

                data[`lang${lang.id}_main`] = true;

                this.propertyAdvertisementForm.patchValue(data, {
                  emitEvent: false,
                });
              }
            }
          }

          if (
            !this.permissionsService.isMaster(this.loginUser.role?.name) &&
            !this.permissionsService.hasPermission("ACTIVATE_PROPERTIES")
          ) {
            this.propertyAdvertisementForm.controls[
              `option${this.activeId}`
            ].setValue(this.securityActive);
          }

          this.propertyAdvertisementData.data =
            this.propertyAdvertisementForm.value;
          this.propertyAdvertisementData.errors = this.getFormErrors();
          this.propertyAdvertisementData.valid =
            this.propertyAdvertisementForm.valid;
          this.submitted = true;
          this.eventService.broadcast("check-warning-add-property");
        },
      );

      const sub = this.propertyAdvertisementForm.valueChanges
        .pipe(auditTime(150))
        .subscribe(() => {
          this.eventService.broadcast("get-data-tab-advertisement");
          this.eventService.broadcast("check-warning-add-property");
        });

      this.subscriptions.add(sub);

      this.isView = true;
      this.submitted = true;

      setTimeout(() => {
        this.setEletemtConfig();
        this.setWarning();
      });
    });
  }

  hasWarning(controlName: any): boolean {
    if (typeof controlName !== "string") return false;

    return !!this.propertyAdvertisementForm?.get(controlName)?.errors?.[
      "warning"
    ];
  }

  hasLangTitleWarning(lang: any): boolean {
    return this.hasWarning(`lang${lang.id}_title`);
  }

  hasLangDescriptionWarning(lang: any): boolean {
    return this.hasWarning(`lang${lang.id}_description`);
  }

  getMainLangId(): number | null {
    const langs = this.dataToFormInitAdvertisement?.langs ?? [];
    const found = langs.find(
      (lang: any) =>
        this.propertyAdvertisementForm?.get(`lang${lang.id}_main`)?.value ===
        true,
    );
    return found?.id ?? null;
  }

  isMainLanguage(lang: any): boolean {
    return (
      this.propertyAdvertisementForm?.get(`lang${lang.id}_main`)?.value === true
    );
  }

  isTranslatedLanguage(lang: any): boolean {
    if (this.isMainLanguage(lang)) return false;
    if (this.isTitleNotFilled(lang)) return false;
    const title = String(
      this.propertyAdvertisementForm?.get(`lang${lang.id}_title`)?.value ?? "",
    ).trim();
    const desc = this.getDescriptionTextLength(lang);
    return title.length > 0 || desc > 0;
  }

  isPendingTranslationLanguage(lang: any): boolean {
    if (this.isMainLanguage(lang)) return false;
    return this.isTitleNotFilled(lang);
  }

  private isTitleNotFilled(lang: any): boolean {
    const title = String(
      this.propertyAdvertisementForm?.get(`lang${lang.id}_title`)?.value ?? "",
    ).trim();
    if (!title) return true;
    return title.toUpperCase() === "N/A";
  }

  getLangCode(lang: any): string {
    return String(lang?.lang ?? "").toUpperCase();
  }

  getLangName(lang: any): string {
    const providedName = String(lang?.name ?? "").trim();
    if (providedName.length > 0) return providedName;

    const map: Record<string, string> = {
      PT: "Português",
      EN: "Inglês",
      FR: "Francês",
      ES: "Espanhol",
      DE: "Alemão",
      IT: "Italiano",
      NL: "Holandês",
    };
    const code = this.getLangCode(lang);
    return map[code] ?? code;
  }

  getLangFlag(lang: any): string {
    const sourceFlag = String(lang?.flag ?? "").trim();
    if (sourceFlag.length > 0) return sourceFlag;

    const map: Record<string, string> = {
      PT: "assets/images/flags/pt.svg",
      EN: "assets/images/flags/en.svg",
      FR: "assets/images/flags/fr.svg",
      ES: "assets/images/flags/es.svg",
      DE: "assets/images/flags/de.svg",
      IT: "assets/images/flags/italy.svg",
      NL: "assets/images/flags/en.svg",
    };
    const code = this.getLangCode(lang);
    return map[code] ?? "assets/images/flags/en.svg";
  }

  getTitleLength(lang: any): number {
    const value = String(
      this.propertyAdvertisementForm?.get(`lang${lang.id}_title`)?.value ?? "",
    );
    return value.trim().length;
  }

  getDescriptionTextLength(lang: any): number {
    const html = String(
      this.propertyAdvertisementForm?.get(`lang${lang.id}_description`)
        ?.value ?? "",
    );
    return html
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/g, " ")
      .replace(/\u00A0/g, " ")
      .trim().length;
  }

  getDescriptionFeedbackKey(lang: any): string {
    const size = this.getDescriptionTextLength(lang);
    if (size === 0) return "ai-advertisement.feedback.empty";
    if (size < this.descriptionGoodMin) return "ai-advertisement.feedback.short";
    if (size > this.descriptionGoodMax) return "ai-advertisement.feedback.long";
    if (size >= this.descriptionExcellentMin) return "ai-advertisement.feedback.excellent";
    return "ai-advertisement.feedback.good";
  }

  getDescriptionFeedbackClass(lang: any): string {
    const size = this.getDescriptionTextLength(lang);
    if (size === 0) return "is-empty";
    if (size < this.descriptionGoodMin || size > this.descriptionGoodMax) {
      return "is-warning";
    }
    return "is-good";
  }

  canGenerateListingContent(): boolean {
    return !!this.resolveMinimumListingContext();
  }

  private hasAiIntegrationsPermission(): boolean {
    return this.permissionsService.hasPermission("VIEW_AI_INTEGRATIONS");
  }

  isGenerateTitleDisabled(lang: any): boolean {
    return (
      this.aiLoading[`title_${lang?.id}`] ||
      !this.canUseAiService("LISTING_TITLE") ||
      !this.canGenerateListingContent()
    );
  }

  isGenerateDescriptionDisabled(lang: any): boolean {
    return (
      this.aiLoading[`desc_${lang?.id}`] ||
      !this.canUseAiService("LISTING_DESCRIPTION") ||
      !this.canGenerateListingContent()
    );
  }

  isTranslateDisabled(): boolean {
    return (
      this.aiLoading["translate"] ||
      !this.canUseAiService("TRANSLATION") ||
      !this.canTranslateContent()
    );
  }

  getGenerateTitleTooltip(lang: any): string | null {
    if (
      !this.aiLoading[`title_${lang?.id}`] &&
      this.canUseAiService("LISTING_TITLE") &&
      !this.canGenerateListingContent()
    ) {
      return this.translateWithFallback(
        "ai-advertisement.missingContextTooltip",
        "Adicione informacoes como o tipo de imovel para gerar o titulo e descricao.",
      );
    }
    if (
      !this.aiLoading[`title_${lang?.id}`] &&
      this.canUseAiService("LISTING_TITLE") &&
      this.isAiServiceFree("LISTING_TITLE")
    ) {
      const cost = this.aiServiceBaseCosts["LISTING_TITLE"] ?? 0;
      return this.translateWithFallback(
        "ai-advertisement.freeFirstUseTooltip",
        `O primeiro título deste imóvel é grátis. Os seguintes custam ${cost} créditos.`,
        { cost },
      );
    }
    return null;
  }

  getGenerateDescriptionTooltip(lang: any): string | null {
    if (
      !this.aiLoading[`desc_${lang?.id}`] &&
      this.canUseAiService("LISTING_DESCRIPTION") &&
      !this.canGenerateListingContent()
    ) {
      return this.translateWithFallback(
        "ai-advertisement.missingContextTooltip",
        "Adicione informacoes como o tipo de imovel para gerar o titulo e descricao.",
      );
    }
    return null;
  }

  getTranslateTooltip(): string | null {
    if (
      !this.aiLoading["translate"] &&
      this.canUseAiService("TRANSLATION") &&
      !this.canTranslateContent()
    ) {
      return this.translateWithFallback(
        "ai-advertisement.missingTranslationContextTooltip",
        "Preencha titulo e descricao no idioma principal para traduzir.",
      );
    }
    return null;
  }

  get canShowAiOptions(): boolean {
    if (!this.hasAiIntegrationsPermission()) return false;
    if (!this.property) return true;
    return (
      this.permissionsService.checkMasterPermission(
        "EDIT_PROPERTIES",
        this.property?.store?.id,
      ) ||
      this.permissionsService.checkPropertyAgentPermission(
        this.property,
        "EDIT_PROPERTIES",
      )
    );
  }

  /**
   * Form data get
   */
  get form() {
    return this.propertyAdvertisementForm.controls;
  }
  /**
   * Form Validation
   */
  initFormValidation() {
    this.dynamicDataForm();

    this.propertyAdvertisementForm = this.formBuilder.group(
      this.propertyAdvertisementData.data,
    );

    if (
      !this.permissionsService.isMaster(this.loginUser.role?.name) &&
      !this.permissionsService.hasPermission("ACTIVATE_PROPERTIES")
    ) {
      this.securityActive =
        this.propertyAdvertisementForm.controls[`option${this.activeId}`].value;
    }
  }

  dynamicDataForm() {
    if (
      this.propertyAdvertisementData === undefined ||
      this.propertyAdvertisementData === null
    )
      this.propertyAdvertisementData = { data: {} };

    for (let option of this.dataToFormInitAdvertisement?.options) {
      const vo =
        this.propertyAdvertisementData.data[`option${option.id}`] !== undefined
          ? this.propertyAdvertisementData.data[`option${option.id}`]
          : null;
      this.propertyAdvertisementData.data[`option${option.id}`] = vo;
    }

    for (let lang of this.dataToFormInitAdvertisement?.langs) {
      const vt =
        this.propertyAdvertisementData.data[`lang${lang.id}_title`] !==
        undefined
          ? [
              this.propertyAdvertisementData.data[`lang${lang.id}_title`],
              [Validators.required, this.validateTitle()],
            ]
          : [null, [Validators.required, this.validateTitle()]];

      this.propertyAdvertisementData.data[`lang${lang.id}_title`] = vt;

      const vd =
        this.propertyAdvertisementData.data[`lang${lang.id}_description`] !==
        undefined
          ? [
              this.propertyAdvertisementData.data[`lang${lang.id}_description`],
              [Validators.required, this.validateDescription()],
            ]
          : [null, [Validators.required, this.validateDescription()]];

      this.propertyAdvertisementData.data[`lang${lang.id}_description`] = vd;

      this.propertyAdvertisementData.data[`lang${lang.id}_main`] = [
        this.propertyAdvertisementData.data[`lang${lang.id}_main`]
          ? this.propertyAdvertisementData.data[`lang${lang.id}_main`]
          : false,
      ];
    }
  }

  private validateTitle(): ValidatorFn {
    return this.propertyValidationService.warningIfEnabled(
      "advertisement.title",
      (control: AbstractControl) => control?.value === "N/A" || !control?.value,
    );
  }

  private isCkEmpty(value: any): boolean {
    if (value === null || value === undefined) return true;

    const html = String(value);

    // remove tags
    const text = html
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/g, " ")
      .replace(/\u00A0/g, " ")
      .trim();

    return text.length === 0;
  }

  private validateDescription(): ValidatorFn {
    return this.propertyValidationService.warningIfEnabled(
      "advertisement.description",
      (control: AbstractControl) => this.isCkEmpty(control?.value),
    );
  }

  private enabledOrUnknown(ruleKey: string): boolean {
    const rule = this.propertyValidationService.get(ruleKey);

    return rule ? !!rule.enabled : true;
  }

  getFormErrors(): ErrorItem[] {
    const errors: ErrorItem[] = [];

    const titleEnabled = this.enabledOrUnknown("advertisement.title");
    const descEnabled = this.enabledOrUnknown("advertisement.description");

    const langs = this.dataToFormInitAdvertisement?.langs ?? [];

    const mainLang = langs?.find(
      (lang: any) =>
        this.propertyAdvertisementData?.data?.[`lang${lang.id}_main`],
    )?.id;

    const titleKey = `lang${mainLang}_title`;
    const descKey = `lang${mainLang}_description`;

    if (titleEnabled) {
      const title = this.propertyAdvertisementData?.data?.[titleKey];

      const titleEmpty =
        title === null ||
        title === undefined ||
        String(title).trim().length === 0 ||
        title === "N/A";

      if (titleEmpty || !mainLang) {
        errors.push({ key: "title", type: { warning: true } });
      }
    }

    if (descEnabled) {
      const desc = this.propertyAdvertisementData?.data?.[descKey];

      const empty = this.isCkEmpty(desc);

      if (empty || !mainLang) {
        errors.push({ key: "description", type: { warning: true } });
      }
    }

    return errors;
  }

  onChangeMainLang(id: any) {
    for (let lang of this.dataToFormInitAdvertisement?.langs) {
      if (!this.hasLangTitleWarning(lang)) {
        if (
          this.propertyAdvertisementForm.get(`lang${lang.id}_main`)?.value ===
            true &&
          lang.id === id
        ) {
          const data: any = {};

          data[`lang${lang.id}_main`] = true;

          this.propertyAdvertisementForm.patchValue(data, { emitEvent: false });
        } else {
          const data: any = {};

          data[`lang${lang.id}_main`] = false;

          this.propertyAdvertisementForm.patchValue(data, { emitEvent: false });
        }
      }
    }
  }

  setEletemtConfig() {
    if (
      !this.permissionsService.checkMasterPermission(
        "EDIT_PROPERTIES",
        this.property?.store?.id,
      ) &&
      !this.permissionsService.checkPropertyAgentPermission(
        this.property,
        "EDIT_PROPERTIES",
      ) &&
      this.property
    ) {
      if (this.formElementRef.nativeElement) {
        const tabContent =
          this.formElementRef.nativeElement.querySelector(".tab-content");
        if (tabContent) {
          this.renderer.setStyle(tabContent, "pointer-events", "none");
          const parentElement = tabContent.parentElement;
          if (parentElement) {
            this.renderer.setStyle(parentElement, "cursor", "not-allowed");
          }
        }

        const statusAdvert =
          this.formElementRef.nativeElement.querySelector(".status-advert");
        if (statusAdvert) {
          this.renderer.setStyle(statusAdvert, "pointer-events", "none");
          const parentElement = statusAdvert.parentElement;
          if (parentElement)
            this.renderer.setStyle(parentElement, "cursor", "not-allowed");
        }
      }
    }
  }

  setWarning() {
    if (
      this.property?.mainAgent !== this.propertiesService.getUserAuth().id &&
      !this.permissionsService.isMaster(
        this.propertiesService.getUserAuth().role?.name,
      ) &&
      this.property
    ) {
      if (this.formElementRef.nativeElement) {
        const tabContent =
          this.formElementRef.nativeElement.querySelector(".tab-content");
        if (tabContent) {
          const parentElement = tabContent.parentElement;
          if (parentElement) {
            const warning = parentElement.querySelectorAll(".is-warning");
            if (warning) {
              warning?.forEach((el: any) => {
                this.renderer.removeClass(el, "is-warning");
              });
            }
          }
        }
      }
    }
  }

  activeIdChangeNabTab(nextId?: number) {
    if (typeof nextId === "number") this.activeTabSubject$.next(nextId);
    setTimeout(() => {
      this.setWarning();
    });
  }

  isOptionVisible(option: any) {
    if (!option?.storeId) return true;
    const storeId = this.positiveInt(
      this.firstNonEmpty(
        this.propertyFormDataSnapshot?.details?.store,
        this.property?.store?.id,
      ),
    );
    return !!storeId && storeId === option.storeId;
  }

  checkPermissionsByOption(option: any) {
    if (option?.key === "Active") {
      return (
        this.permissionsService.checkMasterPermission(
          "ACTIVATE_PROPERTIES",
          this.property?.store?.id,
        ) ||
        this.permissionsService.checkPropertyAgentPermission(
          this.property,
          "ACTIVATE_PROPERTIES",
        )
      );
    } else if (option?.key === "Highlights") {
      return (
        this.permissionsService.checkMasterPermission(
          "HIGHLIGHT_PROPERTIES",
          this.property?.store?.id,
        ) ||
        this.permissionsService.checkPropertyAgentPermission(
          this.property,
          "HIGHLIGHT_PROPERTIES",
        )
      );
    } else if (option?.key === "MLS") {
      return (
        this.permissionsService.checkMasterPermission(
          "MLS_PROPERTIES",
          this.property?.store?.id,
        ) ||
        this.permissionsService.checkPropertyAgentPermission(
          this.property,
          "MLS_PROPERTIES",
        )
      );
    } else if (option?.type === "TAG" || option?.entityId != null) {
      return (
        this.permissionsService.checkMasterPermission(
          "HIGHLIGHT_PROPERTIES",
          this.property?.store?.id,
        ) ||
        this.permissionsService.checkPropertyAgentPermission(
          this.property,
          "HIGHLIGHT_PROPERTIES",
        )
      );
    } else {
      return true;
    }
  }

  ngOnDestroy(): void {
    this.flushPendingTypewriterFills();
    this.clearTypewriterTimers();
    // Criação abandonada sem gravar: as chaves não podem ligar-se a outro imóvel.
    // Na gravação o pai já fez `commit` antes de fechar o modal.
    if (!this.property?.id) this.aiUsageLink.clear();
    this.eventService.broadcast("get-data-tab-advertisement");
    this.subscriptionSubmitted.unsubscribe();
    this.subscriptions.unsubscribe();

    if (this.propertyAdvertisementForm) {
      this.propertyAdvertisementData.data =
        this.propertyAdvertisementForm.value;
      this.propertyAdvertisementData.errors = this.getFormErrors();
      this.propertyAdvertisementData.valid =
        this.propertyAdvertisementForm.valid;

      this.eventService.broadcast("check-warning-add-property");
    }

    this.destroy$.next();
    this.destroy$.complete();
  }

  // AI helpers
  private aiIdempotencyKey(prefix: string): string {
    return `${prefix}_${this.property?.id ?? "new"}_${Date.now()}`;
  }

  /** Mostra badge flutuante de créditos consumidos junto ao campo */
  private showCreditPop(fieldKey: string, credits: number) {
    const id = ++this._popCounter;
    const text =
      credits > 0
        ? `-${credits} cr`
        : this.translateWithFallback("ai-advertisement.freeFirstUse", "Grátis");
    this.aiCreditPops[fieldKey] = { text, id };
    setTimeout(() => {
      if (this.aiCreditPops[fieldKey]?.id === id) {
        delete this.aiCreditPops[fieldKey];
      }
    }, 1700);
  }

  private setLatestResult(
    kind: "TITLE" | "DESCRIPTION" | "TRANSLATION",
    headline: string,
    detail?: string,
    preview?: string,
  ) {
    this.aiLatestResult = { kind, headline, detail, preview, at: Date.now() };
  }

  private setFieldResult(fieldKey: string, value: string) {
    const cleaned = (value ?? "").replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
    this.aiFieldResults[fieldKey] = cleaned;
    setTimeout(() => {
      if (this.aiFieldResults[fieldKey] === cleaned) delete this.aiFieldResults[fieldKey];
    }, 7000);
  }

  /** Efeito typewriter: preenche o campo letra a letra */
  private typewriterFill(controlName: string, text: string, fieldKey: string, speed = 22) {
    this.clearTypewriterTimer(fieldKey);
    this.aiFillingFields[fieldKey] = true;
    this.pendingTypewriterFinalValues[fieldKey] = { controlName, text };

    let i = 0;
    const effectiveSpeed = Math.max(5, Math.floor(speed));
    const targetDurationMs = 2200;
    const estimatedTicks = Math.max(1, Math.floor(targetDurationMs / effectiveSpeed));
    const charsPerTick = Math.max(1, Math.ceil(Math.max(1, text.length) / estimatedTicks));

    const interval = setInterval(() => {
      i = Math.min(text.length, i + charsPerTick);
      const patch: any = {};
      patch[controlName] = text.slice(0, i);
      this.propertyAdvertisementForm.patchValue(patch, { emitEvent: false });
      if (i >= text.length) {
        this.finalizeTypewriterField(fieldKey);
      }
    }, effectiveSpeed);

    this.activeTypewriterTimers[fieldKey] = interval;
  }

  /** Efeito de glow + preenchimento imediato para CKEditor */
  private glowFill(controlName: string, value: string, fieldKey: string) {
    this.aiFillingFields[fieldKey] = true;
    const patch: any = {};
    patch[controlName] = value;
    this.propertyAdvertisementForm.patchValue(patch);
    this.setFieldResult(fieldKey, value);
    setTimeout(() => delete this.aiFillingFields[fieldKey], 2000);
  }

  private markFieldAsAnimated(fieldKey: string, duration = 1800) {
    this.aiFillingFields[fieldKey] = true;
    setTimeout(() => delete this.aiFillingFields[fieldKey], duration);
  }

  private clearTypewriterTimer(fieldKey: string) {
    if (!this.activeTypewriterTimers[fieldKey]) return;
    clearInterval(this.activeTypewriterTimers[fieldKey]);
    delete this.activeTypewriterTimers[fieldKey];
  }

  private clearTypewriterTimers() {
    for (const fieldKey of Object.keys(this.activeTypewriterTimers)) {
      this.clearTypewriterTimer(fieldKey);
    }
  }

  private finalizeTypewriterField(fieldKey: string) {
    this.clearTypewriterTimer(fieldKey);
    const pending = this.pendingTypewriterFinalValues[fieldKey];
    if (!pending) return;

    const final: any = {};
    final[pending.controlName] = pending.text;
    this.propertyAdvertisementForm.patchValue(final);
    this.setFieldResult(fieldKey, pending.text);
    delete this.pendingTypewriterFinalValues[fieldKey];
    setTimeout(() => delete this.aiFillingFields[fieldKey], 200);
  }

  private flushPendingTypewriterFills() {
    for (const fieldKey of Object.keys(this.pendingTypewriterFinalValues)) {
      this.finalizeTypewriterField(fieldKey);
    }
  }

  private resolveErrorPayload(payload: any): { message: string; code: string } {
    const code = String(
      payload?.errorCode ??
        payload?.error?.errorCode ??
        payload?.code ??
        "",
    ).toUpperCase();

    const message =
      payload?.errorMessage ??
      payload?.error?.errorMessage ??
      payload?.error?.message ??
      payload?.message ??
      this.translateService.instant("ai-feedback.genericErrorBody");

    return { message, code };
  }

  /**
   * Quando o imóvel passa a ter id (gravado pelo pai) o custo do título pode
   * passar a "Grátis": recarrega-se sem obrigar a um reload da página.
   */
  ngOnChanges(changes: SimpleChanges) {
    const change = changes["property"];
    if (!change || change.firstChange) return;
    const previousId = change.previousValue?.id;
    const currentId = change.currentValue?.id;
    if (currentId && currentId !== previousId && this.canShowAiOptions) {
      this.loadActivatedAiServices();
    }
  }

  private loadActivatedAiServices(options?: { keepAvailability?: boolean }) {
    // `keepAvailability`: só refresca custos, sem desativar os botões entretanto.
    if (!options?.keepAvailability) this.aiServiceAvailabilityLoaded = false;
    // Com o id do imóvel o servidor diz se o próximo título é grátis.
    this.aiService.getServicesWithStatus(this.property?.id).subscribe({
      next: (services) => {
        const activated = new Set<string>();
        const costs: Record<string, number> = {};
        const baseCosts: Record<string, number> = {};
        const freeFirstUse = new Set<string>();

        for (const service of services ?? []) {
          const code = String(service?.code ?? "").toUpperCase();
          if (!code) continue;
          if (service?.activated) activated.add(code);
          if (service?.firstUseFree) freeFirstUse.add(code);
          const effectiveCost = Number(service?.effectiveCreditCost);
          const nextCost = Number(service?.nextUsageCost);
          if (Number.isFinite(effectiveCost)) {
            baseCosts[code] = effectiveCost;
            costs[code] = Number.isFinite(nextCost) ? nextCost : effectiveCost;
            continue;
          }
          if (Number.isFinite(service?.defaultCreditCost)) {
            baseCosts[code] = Number(service.defaultCreditCost);
            costs[code] = Number(service.defaultCreditCost);
          }
        }

        this.aiServiceCosts = costs;
        this.aiServiceBaseCosts = baseCosts;
        this.aiFreeFirstUse = freeFirstUse;
        this.activatedAiServices = activated;
        this.aiServiceAvailabilityLoaded = true;
      },
      error: () => {
        this.activatedAiServices = new Set<string>();
        this.aiServiceAvailabilityLoaded = true;
      },
    });
  }

  private loadCreditRequestContext() {
    this.aiService.getCreditRequestContext().subscribe({
      next: (ctx) => {
        this.creditRequestContext = ctx;
        this.canRequestCreditTopUps = ctx?.canRequestCredits ?? true;
      },
      error: () => {
        this.creditRequestContext = null;
        this.canRequestCreditTopUps = true;
      },
    });
  }

  canUseAiService(serviceCode: string): boolean {
    if (!this.aiServiceAvailabilityLoaded) return false;
    return this.activatedAiServices.has(String(serviceCode || "").toUpperCase());
  }

  getAiServiceCost(serviceCode: string): number {
    const code = String(serviceCode || "").toUpperCase();
    return Number(this.aiServiceCosts[code] ?? 0);
  }

  /** O próximo uso deste serviço é grátis (ex.: primeiro título do imóvel). */
  isAiServiceFree(serviceCode: string): boolean {
    return this.aiFreeFirstUse.has(String(serviceCode || "").toUpperCase());
  }

  /** Depois do uso grátis o botão volta a mostrar o custo configurado. */
  private markFirstUseConsumed(serviceCode: string) {
    const code = String(serviceCode || "").toUpperCase();
    if (!this.aiFreeFirstUse.delete(code)) return;
    this.aiServiceCosts[code] = Number(
      this.aiServiceBaseCosts[code] ?? this.aiServiceCosts[code] ?? 0,
    );
  }

  private formatCreditAmount(value: number | null): string {
    if (value === null || !Number.isFinite(value)) {
      return this.translateService.instant("ai-feedback.creditConfirm.balanceUnavailable");
    }
    return `${Math.max(0, Math.floor(value)).toLocaleString("pt-PT")} ${this.translateService.instant("ai-feedback.creditConfirm.creditsLabel")}`;
  }

  private getCurrentWalletBalance(): number | null {
    const value = this.aiWalletState.balance;
    if (typeof value !== "number" || !Number.isFinite(value)) return null;
    return Math.max(0, value);
  }

  private getServiceSummary(serviceCode: string): { title: string; description: string; icon: string } {
    const code = String(serviceCode || "").toUpperCase();
    if (code === "LISTING_TITLE") {
      return {
        title: this.translateService.instant("ai-feedback.creditConfirm.services.title.name"),
        description: this.translateService.instant("ai-feedback.creditConfirm.services.title.description"),
        icon: "ri-text",
      };
    }
    if (code === "LISTING_DESCRIPTION") {
      return {
        title: this.translateService.instant("ai-feedback.creditConfirm.services.description.name"),
        description: this.translateService.instant("ai-feedback.creditConfirm.services.description.description"),
        icon: "ri-file-text-line",
      };
    }
    return {
      title: this.translateService.instant("ai-feedback.creditConfirm.services.translation.name"),
      description: this.translateService.instant("ai-feedback.creditConfirm.services.translation.description"),
      icon: "ri-translate-2",
    };
  }

  private async confirmCreditConsumption(serviceCode: string, contextKey: string): Promise<boolean> {
    const cost = Math.max(0, Number(this.getAiServiceCost(serviceCode) || 0));
    // Uso grátis: não há créditos a confirmar nem saldo a verificar.
    if (cost === 0 && this.isAiServiceFree(serviceCode)) return true;
    const currentBalance = this.getCurrentWalletBalance();
    const projectedBalance =
      currentBalance === null ? null : currentBalance - cost;
    const insufficient =
      projectedBalance !== null && projectedBalance < 0;
    const service = this.getServiceSummary(serviceCode);
    const canRequestTopUps = this.canRequestCreditTopUps;

    const result = await Swal.fire({
      title: this.translateService.instant("ai-feedback.creditConfirm.title"),
      text: this.translateService.instant("ai-feedback.creditConfirm.subtitle"),
      html: `
        <div class="ai-credit-cost-modal">
          <div class="ai-credit-cost-section">
            <div class="ai-credit-cost-section__title">${this.translateService.instant("ai-feedback.creditConfirm.selectedServiceLabel")}</div>
            <div class="ai-credit-service-card">
              <div class="ai-credit-service-card__icon"><i class="${service.icon}"></i></div>
              <div class="ai-credit-service-card__content">
                <strong>${service.title}</strong>
                <small>${service.description}</small>
              </div>
              <div class="ai-credit-service-card__cost">
                <strong>${cost}</strong>
                <span>${this.translateService.instant("ai-feedback.creditConfirm.creditsLabel")}</span>
              </div>
            </div>
          </div>
          <div class="ai-credit-cost-section">
            <div class="ai-credit-cost-section__title">${this.translateService.instant("ai-feedback.creditConfirm.summaryLabel")}</div>
            <div class="ai-credit-confirm__ledger">
              <div class="ai-credit-confirm__row">
                <span>${this.translateService.instant("ai-feedback.creditConfirm.currentBalance")}</span>
                <strong>${this.formatCreditAmount(currentBalance)}</strong>
              </div>
              <div class="ai-credit-confirm__row">
                <span>${this.translateService.instant("ai-feedback.creditConfirm.cost")}</span>
                <strong class="is-cost">-${cost.toLocaleString("pt-PT")} ${this.translateService.instant("ai-feedback.creditConfirm.creditsLabel")}</strong>
              </div>
              <div class="ai-credit-confirm__row ai-credit-confirm__row--result">
                <span>${this.translateService.instant("ai-feedback.creditConfirm.afterBalance")}</span>
                <strong class="${insufficient ? "is-danger" : "is-ok"}">${this.formatCreditAmount(projectedBalance)}</strong>
              </div>
            </div>
            <small class="ai-credit-confirm__hint-info">${this.translateService.instant("ai-feedback.creditConfirm.afterHint")}</small>
            ${insufficient ? `<small class="ai-credit-confirm__hint">${this.translateService.instant("ai-feedback.creditConfirm.insufficientHint")}</small>` : ""}
          </div>
        </div>
      `,
      showCancelButton: !insufficient || canRequestTopUps,
      showCloseButton: true,
      confirmButtonText: insufficient
        ? canRequestTopUps
          ? this.translateService.instant("ai-feedback.requestCreditsAction")
          : this.translateService.instant("t-close")
        : this.translateService.instant("ai-feedback.creditConfirm.confirmWithCost", { cost }),
      cancelButtonText: this.translateService.instant("t-cancel"),
      confirmButtonColor: insufficient ? "#f06548" : "rgb(64, 81, 137)",
      cancelButtonColor: "#878a99",
      customClass: {
        popup: "ai-credit-confirm-popup",
        confirmButton: "ai-credit-confirm-btn ai-credit-confirm-btn--confirm",
        cancelButton: "ai-credit-confirm-btn ai-credit-confirm-btn--cancel",
      },
      buttonsStyling: false,
      preConfirm: () =>
        new Promise((resolve) => {
          const popup = Swal.getPopup();
          popup?.classList.add("ai-credit-confirm-popup--committing");
          setTimeout(() => resolve(true), 450);
        }),
    });

    if (!result.isConfirmed) return false;
    if (insufficient) {
      if (canRequestTopUps) {
        this.promptCreditRequest(contextKey);
      } else {
        this.openGenericAiError(this.translateService.instant("ai-feedback.requestCreditsNotAllowed"));
      }
      return false;
    }
    return true;
  }

  private guardServiceActive(serviceCode: string, contextKey: string): boolean {
    if (this.canUseAiService(serviceCode)) return true;
    this.openGenericAiError(
      this.translateService.instant("ai-feedback.serviceInactiveBody", {
        context: this.translateService.instant(contextKey),
      }),
    );
    return false;
  }

  private isInsufficientCreditsError(payload: any): boolean {
    const { message, code } = this.resolveErrorPayload(payload);
    const normalizedMessage = String(message).toLowerCase();
    return (
      code.includes("INSUFFICIENT") ||
      code.includes("BALANCE") ||
      normalizedMessage.includes("sem créditos") ||
      normalizedMessage.includes("saldo insuficiente") ||
      normalizedMessage.includes("insufficient credit")
    );
  }

  private openGenericAiError(message: string) {
    Swal.fire({
      icon: "error",
      title: this.translateService.instant("ai-feedback.genericErrorTitle"),
      text: message || this.translateService.instant("ai-feedback.genericErrorBody"),
      confirmButtonText: this.translateService.instant("t-close"),
      confirmButtonColor: "rgb(54, 69, 116)",
    });
  }

  private openInsufficientCreditsFlow(contextKey: string, fallbackMessage?: string) {
    const canRequestTopUps = this.canRequestCreditTopUps;
    Swal.fire({
      icon: "warning",
      title: this.translateService.instant("ai-feedback.insufficientCreditsTitle"),
      html: `
        <p class="mb-2">${fallbackMessage || this.translateService.instant("ai-feedback.insufficientCreditsBody")}</p>
        <small class="text-muted">${this.translateService.instant("ai-feedback.insufficientCreditsHint")}</small>
      `,
      showCancelButton: canRequestTopUps,
      confirmButtonText: canRequestTopUps
        ? this.translateService.instant("ai-feedback.requestCreditsAction")
        : this.translateService.instant("t-close"),
      cancelButtonText: this.translateService.instant("t-cancel"),
      confirmButtonColor: "rgb(64, 81, 137)",
      cancelButtonColor: "#878a99",
    }).then((res) => {
      if (res.isConfirmed && canRequestTopUps) this.promptCreditRequest(contextKey);
    });
  }

  private promptCreditRequest(contextKey: string) {
    if (!this.canRequestCreditTopUps) {
      this.openGenericAiError(this.translateService.instant("ai-feedback.requestCreditsNotAllowed"));
      return;
    }

    Swal.fire({
      title: this.translateService.instant("ai-feedback.requestCreditsModalTitle"),
      input: "number",
      inputValue: 50,
      inputAttributes: {
        min: "1",
        step: "1",
      },
      showCancelButton: true,
      confirmButtonText: this.translateService.instant("ai-feedback.requestCreditsSubmit"),
      cancelButtonText: this.translateService.instant("t-cancel"),
      confirmButtonColor: "rgb(64, 81, 137)",
      preConfirm: (value) => {
        const credits = Number(value);
        if (!Number.isFinite(credits) || credits < 1) {
          Swal.showValidationMessage(
            this.translateService.instant("ai-feedback.requestCreditsValidation"),
          );
          return null;
        }
        return credits;
      },
    }).then((res) => {
      if (!res.isConfirmed || !res.value) return;
      const creditsRequested = Number(res.value);
      const reason = this.translateService.instant("ai-feedback.requestCreditsReason", {
        context: this.translateService.instant(contextKey),
      });
      this.aiService
        .createCreditRequest({
          creditsRequested,
          reason,
        })
        .subscribe({
          next: () => {
            Swal.fire({
              icon: "success",
              title: this.translateService.instant("ai-feedback.requestCreditsSuccessTitle"),
              text: this.translateService.instant("ai-feedback.requestCreditsSuccessBody"),
              confirmButtonText: this.translateService.instant("t-close"),
              confirmButtonColor: "rgb(54, 69, 116)",
            });
          },
          error: (err: any) => {
            const { message } = this.resolveErrorPayload(err);
            this.openGenericAiError(message);
          },
        });
    });
  }

  private handleAiError(payload: any, contextKey: string) {
    const { message } = this.resolveErrorPayload(payload);
    if (this.isInsufficientCreditsError(payload)) {
      this.openInsufficientCreditsFlow(contextKey, message);
      return;
    }
    this.openGenericAiError(message);
  }

  private notifyConsumption(res: any) {
    // Replay (cached) ou uso grátis: nada saiu da carteira, não há que descontar.
    if (!res?.ok || res?.cached) return;
    const credits = Number(res.creditsConsumed ?? 1);
    if (credits <= 0) return;
    this.aiWalletState.applyConsumption(res.remainingBalance, credits);
  }

  async generateTitle(lang: any) {
    const minimumContext = this.resolveMinimumListingContext();
    if (!minimumContext) return;
    if (!this.guardServiceActive("LISTING_TITLE", "ai-feedback.context.listingTitle")) return;
    if (!(await this.confirmCreditConsumption("LISTING_TITLE", "ai-feedback.context.listingTitle"))) return;
    const key = `title_${lang.id}`;
    const genericTitle = this.buildGenericTitle(minimumContext);
    this.aiLoading[key] = true;
    const idempotencyKey = this.aiIdempotencyKey("title_" + lang.id);
    this.aiService.executeAiService(
      "LISTING_TITLE",
      idempotencyKey,
      this.property?.id,
      this.buildListingContextInputData(),
    ).subscribe({
      next: (res: any) => {
        this.aiLoading[key] = false;
        if (res.ok) {
          this.showCreditPop(key, res.creditsConsumed ?? 1);
          this.notifyConsumption(res);
          if (this.property?.id) {
            // Com imóvel só há um grátis: o próximo já paga.
            this.markFirstUseConsumed("LISTING_TITLE");
          } else {
            // Sem id (criação): guarda a chave para ligar ao imóvel depois de
            // gravar e pergunta ao servidor se o próximo ainda é grátis.
            this.aiUsageLink.track(idempotencyKey);
            this.loadActivatedAiServices({ keepAvailability: true });
          }
          const generatedTitle = String(res?.output?.title ?? "").trim() || genericTitle;
          this.typewriterFill(`lang${lang.id}_title`, generatedTitle, key);
          this.setLatestResult(
            "TITLE",
            this.translateService.instant("ai-feedback.resultTitleHeadline"),
            this.translateService.instant("ai-feedback.resultTitleDetail", {
              lang: String(lang?.lang ?? "").toUpperCase(),
            }),
            generatedTitle,
          );
        } else {
          this.handleAiError(res, "ai-feedback.context.listingTitle");
        }
      },
      error: (err: any) => {
        this.aiLoading[key] = false;
        this.handleAiError(err, "ai-feedback.context.listingTitle");
      },
    });
  }

  async generateDescription(lang: any) {
    const minimumContext = this.resolveMinimumListingContext();
    if (!minimumContext) return;
    if (!this.guardServiceActive("LISTING_DESCRIPTION", "ai-feedback.context.listingDescription")) return;
    const agentNotes = await this.promptAgentNotes();
    if (agentNotes === null) return;
    if (!(await this.confirmCreditConsumption("LISTING_DESCRIPTION", "ai-feedback.context.listingDescription"))) return;
    const key = `desc_${lang.id}`;
    const genericDescription = this.buildGenericDescription(minimumContext);
    this.aiLoading[key] = true;
    const pendingImages = this.propertyDataService.listingImages ?? [];
    const request$ = pendingImages.length
      ? this.aiService.executeListingDescriptionUpload(
          this.aiIdempotencyKey("desc_" + lang.id),
          pendingImages,
          this.property?.id,
          this.buildListingContextInputData(agentNotes),
        )
      : this.aiService.executeAiService(
          "LISTING_DESCRIPTION",
          this.aiIdempotencyKey("desc_" + lang.id),
          this.property?.id,
          this.buildListingContextInputData(agentNotes),
        );
    request$.subscribe({
      next: (res: any) => {
        this.aiLoading[key] = false;
        if (res.ok) {
          this.showCreditPop(key, res.creditsConsumed ?? 1);
          this.notifyConsumption(res);
          const generatedDescription =
            String(res?.output?.description ?? "").trim() || genericDescription;
          this.typewriterFill(`lang${lang.id}_description`, generatedDescription, key, 8);
          this.setLatestResult(
            "DESCRIPTION",
            this.translateService.instant("ai-feedback.resultDescriptionHeadline"),
            this.translateService.instant("ai-feedback.resultDescriptionDetail", {
              lang: String(lang?.lang ?? "").toUpperCase(),
            }),
            generatedDescription,
          );
        } else {
          this.handleAiError(res, "ai-feedback.context.listingDescription");
        }
      },
      error: (err: any) => {
        this.aiLoading[key] = false;
        this.handleAiError(err, "ai-feedback.context.listingDescription");
      },
    });
  }

  private applyTranslations(translations: Record<string, any>): number {
    if (!translations) return 0;
    const langs = this.dataToFormInitAdvertisement?.langs ?? [];
    let updated = 0;

    for (const lang of langs) {
      const code = String(lang?.lang ?? "").toLowerCase();
      const shortCode = code.slice(0, 2);
      const payload =
        translations?.[code] ??
        translations?.[shortCode] ??
        translations?.[code.toUpperCase()] ??
        translations?.[shortCode.toUpperCase()];

      if (!payload) continue;

      if (typeof payload === "string") {
        this.typewriterFill(`lang${lang.id}_description`, payload, `desc_${lang.id}`, 7);
        updated++;
        continue;
      }

      if (payload?.title) {
        this.typewriterFill(`lang${lang.id}_title`, payload.title, `title_${lang.id}`, 14);
        updated++;
      }

      if (payload?.description) {
        this.typewriterFill(`lang${lang.id}_description`, payload.description, `desc_${lang.id}`, 7);
        updated++;
      }
    }

    return updated;
  }

  private buildTranslationInputData(): string | undefined {
    const langs = this.dataToFormInitAdvertisement?.langs ?? [];
    if (!langs.length) return undefined;

    const mainLang =
      langs.find((lang: any) => this.propertyAdvertisementForm.get(`lang${lang.id}_main`)?.value === true) ??
      langs[0];

    const sourceCode = String(mainLang?.lang ?? "").toLowerCase();
    const sourceTitle =
      this.propertyAdvertisementForm.get(`lang${mainLang?.id}_title`)?.value ?? "";
    const sourceDescription =
      this.propertyAdvertisementForm.get(`lang${mainLang?.id}_description`)?.value ?? "";

    const targets = langs
      .map((lang: any) => String(lang?.lang ?? "").toLowerCase())
      .filter((code: string) => !!code);

    return JSON.stringify({
      source: {
        language: sourceCode,
        title: String(sourceTitle ?? ""),
        description: String(sourceDescription ?? ""),
      },
      targets: [...new Set(targets)],
    });
  }

  private normalizeText(value: any): string | undefined {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "object") return undefined;
    const normalized = String(value).trim();
    return normalized.length ? normalized : undefined;
  }

  private resolveLocalizedField(field: any): string | undefined {
    const direct = this.normalizeText(field);
    if (direct) return direct;
    if (!field || typeof field !== "object" || Array.isArray(field)) return undefined;

    const preferredKeys = ["pt", "pt-PT", "pt_PT", "en", "es", "fr", "de", "it"];
    for (const key of preferredKeys) {
      const value = this.normalizeText(field?.[key]);
      if (value) return value;
    }

    for (const value of Object.values(field)) {
      const text = this.normalizeText(value);
      if (text) return text;
    }

    return undefined;
  }

  private resolveMinimumListingContext():
    | { propertyType: string; businessType: string; district: string }
    | null {
    const details = this.propertyFormDataSnapshot?.details ?? {};
    const address = this.propertyFormDataSnapshot?.address ?? {};
    const source = this.property ?? {};

    const propertyType = this.normalizeText(
      this.firstNonEmpty(
        details?.propertyTypeDescription,
        source?.propertyType?.description,
        source?.propertyType?.name,
      ),
    );

    const businessType = this.normalizeText(
      this.firstNonEmpty(
        details?.businessTypeDescription,
        source?.businessType?.description,
        source?.businessType?.name,
      ),
    );

    const district = this.normalizeText(
      this.firstNonEmpty(
        address?.districtName,
        source?.address?.districtName,
        source?.district?.name,
      ),
    );

    if (!propertyType || !businessType || !district) return null;
    return { propertyType, businessType, district };
  }

  private buildGenericTitle(context: { propertyType: string; businessType: string; district: string }): string {
    return `${context.propertyType} | ${context.businessType} | ${context.district}`;
  }

  private buildGenericDescription(context: { propertyType: string; businessType: string; district: string }): string {
    return `Imóvel ${context.propertyType} para ${context.businessType} no distrito de ${context.district}. Contacte-nos para obter mais detalhes e agendar visita.`;
  }

  private firstNonEmpty(...values: any[]): any {
    for (const value of values) {
      if (value === null || value === undefined) continue;
      if (typeof value === "string" && !value.trim()) continue;
      if (Array.isArray(value) && value.length === 0) continue;
      return value;
    }
    return undefined;
  }

  private positiveNumber(value: any): number | undefined {
    const num = Number(value);
    if (!Number.isFinite(num) || num <= 0) return undefined;
    return num;
  }

  private positiveInt(value: any): number | undefined {
    const num = this.positiveNumber(value);
    if (num === undefined) return undefined;
    return Math.floor(num);
  }

  private normalizeYear(value: any): number | undefined {
    if (value === null || value === undefined) return undefined;
    if (value instanceof Date && !Number.isNaN(value.getTime())) {
      return value.getFullYear();
    }
    const raw = String(value).trim();
    if (!raw) return undefined;
    const fromDate = new Date(raw);
    if (!Number.isNaN(fromDate.getTime())) return fromDate.getFullYear();
    const asNumber = Number(raw);
    if (Number.isFinite(asNumber) && asNumber > 0) return Math.floor(asNumber);
    return undefined;
  }

  private resolveLocalizedLabel(value: any): string | undefined {
    if (value === null || value === undefined) return undefined;

    const direct = this.normalizeText(value);
    if (direct) return direct;

    const directCandidates = [
      value?.description,
      value?.name,
      value?.label,
      value?.title,
      value?.division?.description,
      value?.division?.name,
      value?.nearby?.description,
      value?.nearby?.name,
      value?.unit?.description,
      value?.unit?.name,
    ];

    for (const candidate of directCandidates) {
      const label = this.resolveLocalizedField(candidate);
      if (label) return label;
    }

    const candidates = [
      value?.divisionTranslations,
      value?.nearbyTranslations,
      value?.unitTranslations,
      value?.characteristicsTranslations,
      value?.translations,
    ];

    for (const list of candidates) {
      if (!Array.isArray(list)) continue;
      for (const item of list) {
        const label =
          this.resolveLocalizedField(item?.description) ??
          this.resolveLocalizedField(item?.name) ??
          this.resolveLocalizedField(item?.label) ??
          this.resolveLocalizedField(item?.title);
        if (label) return label;
      }
    }

    return undefined;
  }

  private cleanPayload<T>(payload: T): T | undefined {
    if (payload === null || payload === undefined) return undefined;

    if (Array.isArray(payload)) {
      const cleanedArray = payload
        .map((item) => this.cleanPayload(item))
        .filter((item) => item !== undefined);
      return (cleanedArray.length ? cleanedArray : undefined) as T | undefined;
    }

    if (typeof payload === "object") {
      const entries = Object.entries(payload as Record<string, any>)
        .map(([key, value]) => [key, this.cleanPayload(value)] as const)
        .filter(([, value]) => value !== undefined);
      if (!entries.length) return undefined;
      return Object.fromEntries(entries) as T;
    }

    if (typeof payload === "string") {
      const normalized = payload.trim();
      return (normalized.length ? normalized : undefined) as T | undefined;
    }

    return payload;
  }

  private async promptAgentNotes(): Promise<string | null> {
    const result = await Swal.fire({
      title: this.translateService.instant("ai-advertisement.notesTitle"),
      text: this.translateService.instant("ai-advertisement.notesHint"),
      input: "textarea",
      inputPlaceholder: this.translateService.instant("ai-advertisement.notesPlaceholder"),
      inputAttributes: { maxlength: "600" },
      showCancelButton: true,
      confirmButtonText: this.translateService.instant("ai-advertisement.notesConfirm"),
      cancelButtonText: this.translateService.instant("t-cancel"),
      confirmButtonColor: "rgb(64, 81, 137)",
      cancelButtonColor: "#878a99",
    });
    if (!result.isConfirmed) return null;
    return String(result.value ?? "").trim();
  }

  private buildListingContextInputData(agentNotes?: string): string | undefined {
    const details = this.propertyFormDataSnapshot?.details ?? {};
    const address = this.propertyFormDataSnapshot?.address ?? {};
    const source = this.property ?? {};
    const areasNearby = this.firstNonEmpty(
      this.propertyFormDataSnapshot?.areasNearby,
      this.propertyAreasNearbyData?.data,
      source?.areasNearby,
      {},
    ) ?? {};
    const rawCharacteristics = this.firstNonEmpty(
      this.propertyCharateristicsData?.data,
      source?.charateristics,
      source?.characteristics,
      source?.features,
    );

    const divisions = Object.keys(areasNearby)
      .filter((key) => key.startsWith("division"))
      .map((key) => {
        const type = this.positiveInt(key.replace("division", ""));
        const value = this.positiveInt(this.unwrapControlValue(areasNearby[key]));
        if (!type || !value) return undefined;

        const sizes = Object.keys(areasNearby)
          .filter((inputKey) => inputKey.startsWith(`areaInput-${type}-`))
          .map((inputKey) => {
            const order = Number(inputKey.split(`areaInput-${type}-`)[1] ?? 0);
            return {
              order: Number.isFinite(order) && order > 0 ? order : Number.MAX_SAFE_INTEGER,
              value: this.positiveNumber(this.unwrapControlValue(areasNearby[inputKey])),
            };
          })
          .filter((item) => item.value !== undefined)
          .sort((a, b) => a.order - b.order);

        return {
          type,
          value,
          size: sizes.map((entry) => entry.value as number),
        };
      })
      .filter((item) => !!item) as Array<{ type: number; value: number; size?: number[] }>;

    const nearby = Object.keys(areasNearby)
      .filter((key) => key.startsWith("nearby") && !!this.unwrapControlValue(areasNearby[key]))
      .map((key) => {
        const type = this.positiveInt(key.replace("nearby", ""));
        if (!type) return undefined;

        return {
          type,
          distance: this.positiveNumber(this.unwrapControlValue(areasNearby[`valNearby-${type}`])),
          unit: this.positiveInt(this.unwrapControlValue(areasNearby[`unitNearBy-${type}`])),
        };
      })
      .filter((item) => !!item) as Array<{ type: number; distance?: number; unit?: number }>;

    const characteristicsSelectedIds = this.extractSelectedCharacteristicIds(rawCharacteristics);
    const charGroups = this.extractCharacteristicGroupSelections(rawCharacteristics);
    const hidePropertyAddress = this.toBoolean(
      this.firstNonEmpty(address?.hidePropertyAddress, source?.hidePropertyAddress),
    );
    const propertyType2Id = this.positiveInt(this.firstNonEmpty(details?.propertyType2, source?.propertyType2?.id));

    const context: Record<string, any> = {
      propertyId: this.property?.id,
      storeId: this.positiveInt(this.firstNonEmpty(details?.store, source?.store?.id)),
      propertyTypeId: this.positiveInt(this.firstNonEmpty(details?.propertyType, source?.propertyType?.id)),
      propertyType2Id,
      propertyTypeContext: propertyType2Id ? "propertyType2" : "propertyType",
      conditionId: this.positiveInt(this.firstNonEmpty(details?.condition, source?.condition?.id)),
      businessTypeId: this.positiveInt(this.firstNonEmpty(details?.businessType, source?.businessType?.id)),
      year: this.normalizeYear(
        this.firstNonEmpty(details?.yearOfConstruction, source?.yearOfConstruction),
      ),
      price: this.positiveNumber(this.firstNonEmpty(details?.price, source?.price)),
      condoPrice: this.positiveNumber(this.firstNonEmpty(details?.propertyValue, source?.propertyValue)),
      energyCertificationId: this.positiveInt(this.firstNonEmpty(details?.ec, source?.ec?.id)),
      renewableEnergy: this.positiveNumber(this.firstNonEmpty(details?.renewableEnergy, source?.renewableEnergy)),
      districtId: this.positiveInt(this.firstNonEmpty(address?.district, source?.district?.id)),
      countyId: this.positiveInt(this.firstNonEmpty(address?.county, source?.county?.id)),
      parishId: this.positiveInt(this.firstNonEmpty(address?.parish, source?.parish?.id)),
      hidePropertyAddress,
      grossArea: this.positiveNumber(
        this.firstNonEmpty(this.unwrapControlValue(areasNearby?.grossArea), source?.areasNearby?.grossArea),
      ),
      usefulArea: this.positiveNumber(
        this.firstNonEmpty(this.unwrapControlValue(areasNearby?.usefulArea), source?.areasNearby?.usefulArea),
      ),
      landArea: this.positiveNumber(
        this.firstNonEmpty(this.unwrapControlValue(areasNearby?.landArea), source?.areasNearby?.landArea),
      ),
      divisions,
      nearby,
      chars: characteristicsSelectedIds,
      charGroups,
      agentNotes: agentNotes?.trim() ? agentNotes.trim().slice(0, 600) : undefined,
    };

    const cleaned = this.cleanPayload(context);
    return cleaned ? JSON.stringify(cleaned) : undefined;
  }

  private unwrapControlValue(value: any): any {
    if (!Array.isArray(value)) return value;
    if (value.length === 0) return undefined;
    return value[0];
  }

  private toBoolean(value: any): boolean {
    const normalized = this.unwrapControlValue(value);
    if (typeof normalized === "boolean") return normalized;
    if (typeof normalized === "number") return normalized > 0;
    if (typeof normalized === "string") {
      const lower = normalized.trim().toLowerCase();
      return lower === "true" || lower === "1" || lower === "yes" || lower === "sim";
    }
    return !!normalized;
  }

  private extractSelectedCharacteristicIds(raw: any): number[] {
    const ids = new Set<number>();

    if (Array.isArray(raw)) {
      raw.forEach((item) => {
        const id = this.positiveInt(item?.id ?? item);
        if (id) ids.add(id);
      });
      return Array.from(ids);
    }

    if (raw && typeof raw === "object") {
      Object.entries(raw).forEach(([key, value]) => {
        if (!this.toBoolean(value)) return;
        const match = key.match(/_char(\d+)(?:_value)?$/i);
        if (match?.[1]) {
          const id = this.positiveInt(match[1]);
          if (id) ids.add(id);
        }
      });
      return Array.from(ids);
    }

    return [];
  }

  private extractCharacteristicGroupSelections(
    raw: any,
  ): Array<{ groupTypeId: number; charIds: number[] }> {
    const byGroup = new Map<number, Set<number>>();

    if (raw && typeof raw === "object" && !Array.isArray(raw)) {
      Object.entries(raw).forEach(([key, value]) => {
        if (!this.toBoolean(value)) return;
        const match = key.match(/^p(\d+)_char(\d+)(?:_value)?$/i);
        if (!match?.[1] || !match?.[2]) return;
        const groupTypeId = this.positiveInt(match[1]);
        const charId = this.positiveInt(match[2]);
        if (!groupTypeId || !charId) return;
        if (!byGroup.has(groupTypeId)) byGroup.set(groupTypeId, new Set<number>());
        byGroup.get(groupTypeId)?.add(charId);
      });
    }

    if (!byGroup.size && Array.isArray(this.dataToFormInitChar?.characteristics)) {
      const selected = new Set(this.extractSelectedCharacteristicIds(raw));
      for (const group of this.dataToFormInitChar.characteristics) {
        const groupTypeId = this.positiveInt(group?.id);
        if (!groupTypeId) continue;
        for (const char of group?.char ?? []) {
          const charId = this.positiveInt(char?.id);
          if (!charId || !selected.has(charId)) continue;
          if (!byGroup.has(groupTypeId)) byGroup.set(groupTypeId, new Set<number>());
          byGroup.get(groupTypeId)?.add(charId);
        }
      }
    }

    return Array.from(byGroup.entries())
      .map(([groupTypeId, ids]) => ({
        groupTypeId,
        charIds: Array.from(ids.values()).sort((a, b) => a - b),
      }))
      .filter((item) => item.charIds.length > 0);
  }

  private resolveCharacteristicLabels(ids: number[]): string[] {
    if (!ids.length) return [];
    const map = new Map<number, string>();
    for (const group of this.dataToFormInitChar?.characteristics ?? []) {
      for (const char of group?.char ?? []) {
        const id = this.positiveInt(char?.id);
        const label = this.resolveLocalizedLabel(char);
        if (id && label) map.set(id, label);
      }
    }

    return ids
      .map((id) => map.get(id))
      .filter((label): label is string => !!label);
  }

  private buildDivisionsText(
    divisions: Array<{ label?: string; count?: number; area?: Array<{ value?: number }> }>,
  ): string | undefined {
    const items = (divisions ?? [])
      .map((division) => {
        const label = this.normalizeText(division?.label);
        if (!label) return "";
        const count = this.positiveInt(division?.count);
        if (count !== undefined) return `${count} ${label}`;
        return label;
      })
      .filter((item) => !!item);

    if (!items.length) return undefined;
    return items.join("; ");
  }

  private buildProximitiesText(
    proximities: Array<{ label?: string; value?: number; unitLabel?: string }>,
  ): string | undefined {
    const items = (proximities ?? [])
      .map((item) => {
        const label = this.normalizeText(item?.label);
        if (!label) return "";
        const value = this.positiveNumber(item?.value);
        const unit = this.normalizeText(item?.unitLabel);
        if (value !== undefined) {
          return `${label} (${value}${unit ? ` ${unit}` : ""})`;
        }
        return label;
      })
      .filter((entry) => !!entry);

    if (!items.length) return undefined;
    return items.join("; ");
  }

  canTranslateContent(): boolean {
    const langs = this.dataToFormInitAdvertisement?.langs ?? [];
    if (!langs.length) return false;

    const mainLangId = this.getMainLangId() ?? langs[0]?.id;
    if (!mainLangId) return false;

    const title = String(
      this.propertyAdvertisementForm?.get(`lang${mainLangId}_title`)?.value ?? "",
    ).trim();
    const descriptionLength = this.getDescriptionTextLength({ id: mainLangId });

    const hasTitle = title.length > 0 && title.toUpperCase() !== "N/A";
    const hasDescription = descriptionLength > 0;

    return hasTitle && hasDescription;
  }

  private translateWithFallback(
    key: string,
    fallback: string,
    params?: Record<string, any>,
  ): string {
    const translated = this.translateService.instant(key, params);
    return translated && translated !== key ? translated : fallback;
  }

  async translateContent() {
    if (!this.guardServiceActive("TRANSLATION", "ai-feedback.context.translation")) return;
    if (!this.canTranslateContent()) return;
    if (!(await this.confirmCreditConsumption("TRANSLATION", "ai-feedback.context.translation"))) return;
    this.aiLoading["translate"] = true;
    this.aiTranslationPulse = false;
    this.aiService.executeAiService(
      "TRANSLATION",
      this.aiIdempotencyKey("translate"),
      this.property?.id,
      this.buildTranslationInputData(),
    ).subscribe({
      next: (res: any) => {
        this.aiLoading["translate"] = false;
        if (res.ok && res.output?.translations) {
          this.showCreditPop("translate", res.creditsConsumed ?? 1);
          this.notifyConsumption(res);
          const changed = this.applyTranslations(res.output.translations);
          this.aiTranslationPulse = true;
          setTimeout(() => (this.aiTranslationPulse = false), 1600);
          this.setLatestResult(
            "TRANSLATION",
            this.translateService.instant("ai-feedback.resultTranslationHeadline"),
            this.translateService.instant("ai-feedback.resultTranslationDetail", {
              count: changed || 1,
            }),
          );
        } else {
          this.handleAiError(res, "ai-feedback.context.translation");
        }
      },
      error: (err: any) => {
        this.aiLoading["translate"] = false;
        this.handleAiError(err, "ai-feedback.context.translation");
      },
    });
  }
}


